export enum PurchaseType {
  Subscription = 'subscription',
  Single = 'single',
}

export default null;
